/**
 * Interface to define what properties/methods are required for an Overlay source.
 */
export class OverlaySource {
  constructor(props) {
    this.ref = props.ref;
    this.onCloseRequest = props.onCloseRequest;
    this.getIsPreventClose = props.getIsPreventClose;
    this.getShouldBlockInteractOutsideOverride = props.getShouldBlockInteractOutside;
    this.getShouldCloseOnOverlayOpenOverride = props.getShouldCloseOnOverlayOpen;
  }

  /**
   * Whether an interaction that closes this overlay should be swallowed. A non-blocking overlay
   * (e.g. a tooltip) still closes, but lets the pointer event reach its target.
   */
  getShouldBlockInteractOutside() {
    return this.getShouldBlockInteractOutsideOverride?.() ?? true;
  }

  /**
   * Whether this overlay closes when an overlay outside its stack opens, e.g. a menu that should
   * not stay open behind a dialog opened with a keyboard shortcut.
   */
  getShouldCloseOnOverlayOpen() {
    return this.getShouldCloseOnOverlayOpenOverride?.() ?? false;
  }
}
